"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
require("cross-fetch/polyfill");
var _config = _interopRequireDefault(require("../config/config.json"));
var _configOptions = require("../constants/config-options");
var _formatter = _interopRequireDefault(require("../lib/formatter"));
var _log = _interopRequireDefault(require("../lib/log"));
var _formatName = _interopRequireDefault(require("../utils/formatName"));
var _fetchRetry = _interopRequireDefault(require("fetch-retry"));
var _excluded = ["timestamp", "client-adjusted-timestamp"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var minimumStatement = {
  actor: {
    account: {
      homePage: 'not-set',
      name: 'not-set'
    }
  },
  verb: {
    id: 'not-set',
    display: {
      'en-US': 'not-set'
    }
  },
  object: {
    id: 'not-set',
    objectType: 'Activity'
  }
};

/**
 * Build and return IRI for an xAPI statement element.
 *
 * @param {String} type The type of the element like, 'verb' or 'extensions/object'.
 * @param {String} value
 * @return {String} Formatted IRI.
 */
function getIri(type, value) {
  return "https://api.amplify.com/xapi/".concat(type, "s/").concat(value);
}

/**
 * Wrapper around Amplify event endpoint that
 * generates events in the xAPI format.
 * 8/15/2017 - Mike Z. first version based on
 * amp-event lib: https://github.com/amplify-education/amp-event
 */
var xApiStatementFactory = /*#__PURE__*/function () {
  function xApiStatementFactory(options, environment, useBulkOnStashedEvents, _eventService) {
    _classCallCheck(this, xApiStatementFactory);
    this.options = options;
    this.environment = environment;
    this.useBulkOnStashedEvents = useBulkOnStashedEvents;
    this.eventService = _eventService;
    this.fetchWithRetry = (0, _fetchRetry["default"])(fetch, {
      retries: 3,
      retryDelay: function retryDelay(attempt) {
        return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
      }
    });

    if (Object.values(xApiStatementFactory.ENVIRONMENT).includes(environment)) {
      this.events_url = _config["default"][environment].events_url;
      this.bulk_events_url = _config["default"][environment].bulk_events_url;
      this.server_timestamp_url = _config["default"][environment].server_timestamp_url;
    }
  }
  _createClass(xApiStatementFactory, [{
    key: "create",
    value: function create() {
      var _this = this;
      /** ****************
       * Information for assignment of client-adjusted-timestamp *
       ******************/
      var timestampOffsetKey = "timestampOffset-".concat((0, _formatName["default"])(this.options[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(this.options[_configOptions.CONFIG_OPTIONS.USER_ID]);

      /** ****************
       * Base statement *
       ******************/

      var event = {
        statement: (0, _cloneDeep2["default"])(minimumStatement)
      };

      /** ********************************
       * xApiStatement Builder Settings *
       **********************************/

      event.addActor = function (key, value) {
        event.statement.actor[key] = value;
        return event;
      };
      event.addActorAccount = function (key, value) {
        event.statement.actor.account[key] = value;
        return event;
      };
      event.addVerb = function (key, value) {
        event.statement.verb[key] = value;
        return event;
      };
      event.addVerbId = function (id) {
        event.statement.verb.id = getIri('verb', id);
        return event;
      };
      event.addObject = function (key, value) {
        event.statement.object[key] = value;
        return event;
      };
      event.addObjectId = function (id) {
        event.statement.object.id = id.startsWith('https://') ? id : getIri('object', id);
        return event;
      };
      event.addObjectExtension = function (key, value) {
        if (!event.statement.object.definition) {
          event.statement.object.definition = {
            extensions: {}
          };
        }
        if (!event.statement.object.definition.extensions) {
          event.statement.object.definition.extensions = {};
        }
        event.statement.object.definition.extensions[getIri('extensions/object', key)] = value;
        return event;
      };
      event.addObjectDefinition = function (key, value) {
        if (!event.statement.object.definition) {
          event.statement.object.definition = {};
        }
        event.statement.object.definition[key] = value;
        return event;
      };
      event.addResult = function (key, value) {
        if (!event.statement.result) {
          event.statement.result = {};
        }
        event.statement.result[key] = value;
        return event;
      };
      event.addResultExtension = function (key, value) {
        if (!event.statement.result) {
          event.statement.result = {};
        }
        if (!event.statement.result.extensions) {
          event.statement.result.extensions = {};
        }
        event.statement.result.extensions[getIri('extensions/result', key)] = value;
        return event;
      };
      event.addContext = function (key, value) {
        if (!event.statement.context) {
          event.statement.context = {};
        }
        event.statement.context[key] = value;
        return event;
      };
      event.addContextExtension = function (key, value) {
        if (!event.statement.context) {
          event.statement.context = {};
        }
        if (!event.statement.context.extensions) {
          event.statement.context.extensions = {};
        }
        event.statement.context.extensions[getIri('extensions/context', key)] = value;
        return event;
      };
      event.setTimestamp = function (value) {
        event.statement.timestamp = value;
        event.statement['client-adjusted-timestamp'] = xApiStatementFactory.getCurrentClientAdjustedTimestamp(timestampOffsetKey);
        return event;
      };
      event.setStored = function (value) {
        event.statement.stored = value;
        return event;
      };
      event.addAuthority = function (key, value) {
        event.statement.authority[key] = value;
        return event;
      };

      /** ***************
       * Apply options *
       *****************/

      // Add a library version to every statement.
      event.addContextExtension('library-version', xApiStatementFactory.API_VERSION);
      if (this.options.appVersion) {
        event.addContext('revision', this.options.appVersion);
      }
      if (this.options.appName) {
        event.addContext('platform', this.options.appName);
      }
      if (this.options.language) {
        event.addContext('language', this.options.language);
      }
      if (this.environment && this.events_url) {
        event.addContextExtension('environment', this.environment);
      }
      if (this.options.homePage) {
        event.addActorAccount('homePage', this.options.homePage);
      }
      event.emit = function () {
        if (_this.useBulkOnStashedEvents) {
          _log["default"].info('Using bulk on stashed events::: Event is stored in stash and will be sent in Bulk');
          return _this.eventService.stashEvent(event);
        }
        return _this.emit(event.statement);
      };
      return event;
    }

    // Emit event
  }, {
    key: "emit",
    value: function emit(statement) {
      var _this2 = this;
      var timestampOffsetKey = "timestampOffset-".concat((0, _formatName["default"])(this.options[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(this.options[_configOptions.CONFIG_OPTIONS.USER_ID]);
      var _statement = xApiStatementFactory.prepareStatementForEmit(statement, timestampOffsetKey);
      if (global.AMP_EVENTS_DEBUG_LOG) {
        _log["default"].info("[amp-events] - ".concat(JSON.stringify(_statement, null, 2)));
      }
      return new Promise(function (resolve, reject) {
        if (!_this2.environment || !_this2.events_url) {
          _log["default"].error("Unable to send event::: environment=".concat(_this2.environment, ", url:").concat(_this2.events_url));
          reject('Error sending event');
        }
        _this2.fetchWithRetry(_this2.events_url, {
          priority: 'low',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(_statement)
        }).then(function () {
          _log["default"].debug("Event send success::: ".concat(JSON.stringify(_statement, null, 2)));
          resolve();
        })["catch"](function (error) {
          _log["default"].error("Event send error::: ".concat(error));
          reject(error);
        });
      });
    }

    // emit a group of events using batch endpoint
  }, {
    key: "bulkEmit",
    value: function bulkEmit(events) {
      var _this3 = this;
      if (!events.length) {
        // if there are no events received - no requests executed
        _log["default"].debug('No events received while trying to bulkEmit');
        return;
      }
      var formattedStatements = events.map(function (event) {
        var timestampOffsetKey = "timestampOffset-".concat((0, _formatName["default"])(_this3.options[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(_this3.options[_configOptions.CONFIG_OPTIONS.USER_ID]);
        return xApiStatementFactory.prepareStatementForEmit(event.statement, timestampOffsetKey);
      });
      return new Promise(function (resolve, reject) {
        if (!_this3.environment || !_this3.bulk_events_url) {
          _log["default"].error("Unable to send event::: environment=".concat(_this3.environment, ", url:").concat(_this3.bulk_events_url));
          reject('Error sending event');
        }
        _this3.fetchWithRetry(_this3.bulk_events_url, {
          priority: 'low',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formattedStatements)
        }).then(function (response) {
          if (response.ok) {
            _log["default"].debug("Event bulk send success::: ".concat(JSON.stringify(formattedStatements, null, 2)));
            resolve();
          } else {
            _log["default"].error("Event bulk send error::: ".concat(response.status, ":").concat(response.statusText));
            reject();
          }
        });
      });
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      this.options.language = language;
    }
  }, {
    key: "setHomePage",
    value: function setHomePage(homePage) {
      this.options.homePage = homePage;
    }

    // Getting server timestamp to later calculate the difference between a client and server
  }], [{
    key: "getServerTimestamp",
    value: function getServerTimestamp(environment, serverTimestampUrl) {
      return new Promise(function (resolve, reject) {
        if (!environment || !serverTimestampUrl) {
          _log["default"].error("Unable to get timestamp::: environment=".concat(environment, ", url:").concat(serverTimestampUrl));
          reject('Error getting server timestamp');
        }
        (0, _fetchRetry["default"])(fetch, {
          retries: 3,
          retryDelay: function retryDelay(attempt) {
            return Math.pow(2, attempt) * 1000; // 1000, 2000, 4000
          }
        })(serverTimestampUrl, {
          priority: 'low',
          method: 'GET',
          headers: {
            'Content-Type': 'text/plain'
          }
        }).then(function (response) {
          if (response.ok) {
            resolve(response.text());
          } else {
            _log["default"].error("Get server timestamp error::: ".concat(response.status, ":").concat(response.statusText));
            reject();
          }
        });
      });
    }

    // Getting client timestamp to later calculate the difference between a client and server
  }, {
    key: "getClientTimestamp",
    value: function getClientTimestamp() {
      return Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate(), new Date().getUTCHours(), new Date().getUTCMinutes(), new Date().getUTCSeconds(), new Date().getUTCMilliseconds());
    }

    // Getting adjusted client timestamp for a current moment
  }, {
    key: "getCurrentClientAdjustedTimestamp",
    value: function getCurrentClientAdjustedTimestamp(timestampOffsetKey) {
      var clientTimestamp = xApiStatementFactory.getClientTimestamp();
      try {
        var timestampOffset = localStorage.getItem(timestampOffsetKey);
        if (!timestampOffset) {
          _log["default"].error("Timestamp offset between client and service is not found::: ".concat(timestampOffsetKey));
          return new Date(clientTimestamp).toISOString();
        }
        var clientAdjustedTimestampMS = clientTimestamp + Number(timestampOffset);
        return new Date(clientAdjustedTimestampMS).toISOString();
      } catch (error) {
        _log["default"].error('Error while trying to get Client Adjusted Timestamp based on localStorage offset key');
        return new Date(clientTimestamp).toISOString();
      }
    }
  }, {
    key: "prepareStatementForEmit",
    value: function prepareStatementForEmit(statement, timestampOffsetKey) {
      var existingTimestamp = statement.timestamp,
        existingAdjustedTimestamp = statement['client-adjusted-timestamp'],
        statementToFormat = _objectWithoutProperties(statement, _excluded);
      var _statement = _formatter["default"].formatStatement(statementToFormat);

      // Add timestamp if it is not already set.
      _statement.timestamp = existingTimestamp && existingTimestamp !== '' ? existingTimestamp : new Date().toISOString();

      // Add client-adjusted-timestamp if it's not already set
      _statement['client-adjusted-timestamp'] = existingAdjustedTimestamp && existingAdjustedTimestamp !== '' ? existingAdjustedTimestamp : xApiStatementFactory.getCurrentClientAdjustedTimestamp(timestampOffsetKey);
      return _statement;
    }
  }]);
  return xApiStatementFactory;
}(); // Echo's the current lib version, based on package.json.
xApiStatementFactory.API_VERSION = "5.0.4";
xApiStatementFactory.ENVIRONMENT = _configOptions.ENVIRONMENTS;

// Options available to StatementTemplate.
xApiStatementFactory.OPTIONS = {
  APP_NAME: 'appName',
  APP_VERSION: 'appVersion',
  LANGUAGE: 'language'
};
var _default = xApiStatementFactory;
exports["default"] = _default;
module.exports = exports.default;